import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth/auth.service';

/**
 * Protects routes that only Immutec staff (global admin/engineer) may use,
 * e.g. reseller management. Resellers are sent back to /admin.
 */
export const globalAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isGlobalAdmin() ? true : router.createUrlTree(['/admin']);
};
